module.exports = __webpack_public_path__ + "static/media/ruinitforme.d6e6ace7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/ruinitforme.mp3
// module id = 515
// module chunks = 0